import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {
  BrandAndProductNameWrapper,
  Section,
} from './BrandAndProductNameQuickViewView';

export const BrandAndProductNameQuickViewLoading: React.FC<{
  className?: string;
}> = ({className}) => {
  return (
    <Section className={className}>
      <BrandAndProductNameWrapper>
        <StyledSkeletonBlock
          $width="100%"
          $height="28px"
          disableSpaceBelow
          disableRoundedCorners
        />
      </BrandAndProductNameWrapper>
    </Section>
  );
};

const StyledSkeletonBlock = styled(SkeletonBlock)`
  margin-top: 4px;
`;
